import { useMemo } from "react";
import { lime, indigo } from "@mui/material/colors";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  Box,
  CssBaseline,
  ThemeProvider,
  createTheme,
  useMediaQuery,
} from "@mui/material";

import "./App.css";
import { Docs } from "components/docs/Docs";
import { Users } from "components/user/Users";
import { Audit } from "components/user/Audit";
import { Navbar } from "components/nav/NavBar";
import { Status } from "components/user/Status";
import { Signin } from "components/user/SignIn";
import { Footer } from "components/footer/Footer";
import { Profile } from "components/user/Profile";
import { NotFound } from "components/general/NotFound";
import { Projects } from "components/projects/Projects";
import { Dashboard } from "components/general/Dashboard";
import { SignupLocal } from "components/user/SignupLocal";
import { SigninLocal } from "components/user/SigninLocal";
import { ProjectDetail } from "components/projects/Detail";
import { RequestDetail } from "components/requests/Detail";
import { RequestsClosed } from "components/requests/Closed";
import { RequestsPending } from "components/requests/Pending";

const App = () => {
  const darkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: darkMode ? "dark" : "light",
          primary: {
            main: "#00126E",
            light: indigo[50],
            // dark: "#343541",
          },
          secondary: {
            main: lime.A200,
          },
          ...(darkMode && {
            background: {
              default: "#343541",
              paper: "#343541",
            },
          }),
        },
      }),
    [darkMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh",
          flexDirection: "column",
        }}
      >
        <CssBaseline />

        <Router>
          <Navbar />

          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/users" element={<Users />} />
            <Route path="/status" element={<Status />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/local/signin" element={<SigninLocal />} />
            <Route path="/local/signup" element={<SignupLocal />} />
            <Route path="/projects/:name" element={<ProjectDetail />} />
            <Route path="/requests/closed" element={<RequestsClosed />} />
            <Route path="/requests/pending" element={<RequestsPending />} />
            <Route path="/requests/closed/:id" element={<RequestDetail />} />
            <Route path="/requests/pending/:id" element={<RequestDetail />} />

            <Route path="/*" element={<NotFound />} />
          </Routes>
        </Router>

        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default App;
